/* Global imports. */
import React from "react";
import { nanoid } from 'nanoid';
import HTMLReactParser from "html-react-parser";

/* Component imports. */
import ArticleCard from "@components/ArticleCard";

/* Model imports. */
import { KontentArticleSummary } from "@models/kontent";

interface Props {
  title?: string;
  subtitle?: string;
  subcopy?: string;
  format: "large" | "portrait" | "landscape";
  articleSummaries: Array<{ fields: { slug: string }; elements: KontentArticleSummary }>;
  backgroundColor? : string;
  textColour? : string;
  textAlign? : string;
  componentID?: string;
  referringSlug?: string
}

const FeaturedArticles = ({ title, subtitle, subcopy, format, articleSummaries, backgroundColor, textColour, textAlign, componentID, referringSlug }: Props) => (
  <section id={componentID} data-component="featured-articles">
    <div>
      {(title || subtitle || subcopy && subcopy !== "<p><br></p>") && (
        <div style={{textAlign:`${textAlign}`}}>
          {title && <h3>{title}</h3>}
          {subtitle && <h4>{subtitle}</h4>}
          {subcopy && <>{HTMLReactParser(subcopy)}</>}
        </div>
      )}
      <ul className={` gap-5 !mb-8 gap-x-8 gap-y-8 !pl-0 !list-none ${format == 'landscape' ? 'grid md:grid-cols-2' : 'flex flex-col sm:flex-row'} `}>
        {articleSummaries && articleSummaries.map((articleSummary) => (
          <ArticleCard
            key={nanoid()}
            articleSummary={articleSummary && articleSummary.elements}
            articleURL={articleSummary && articleSummary.fields && articleSummary.fields.slug ? articleSummary.fields.slug : articleSummary && articleSummary.url && articleSummary.url.value }
            format={format}
            backgroundColor={backgroundColor}
            textColour={textColour}
            referringSlug={referringSlug}
          />
        ))}
      </ul>
    </div>
  </section>
);

export default FeaturedArticles;
